import React, { useState, useEffect } from "react";

import { Modal } from "antd";
import {Button} from "components/Button";

const BaseModal = (props) => {
    const [sidebarWidth, setSidebarWidth] = useState(0);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [modalWidth, setModalWidth] = useState(window.innerWidth);
    const [leftMargin, setLeftMargin] = useState(0);
    const HEADER_OFFSET_PX = 64;


  useEffect(() => {
    const updateWidths = () => {
      const sidebar = document.getElementById("sidebar");
      const sidebarW = sidebar ? sidebar.offsetWidth : 0;
      setSidebarWidth(sidebarW);
      setWindowWidth(window.innerWidth);

      // If screen width is less than 768px (mobile), set modal to 100%
      if (window.innerWidth < 768) {
        setModalWidth(window.innerWidth);
        setLeftMargin(0)
      } else {
        setModalWidth(window.innerWidth - sidebarW);
        setLeftMargin(sidebarW)
      }
    };

    // Run initially and on resize
    updateWidths();
    window.addEventListener("resize", updateWidths);

    return () => window.removeEventListener("resize", updateWidths);
  }, []);

  return (
    <>
      <Modal
        {...props}
        mask={props.mask}
        title={props.title}
        // style={{ top: 100 }}
        open={props.open}
        width={modalWidth}
        height={`calc(100vh - ${HEADER_OFFSET_PX}px)`}
        footer={[]}
        // onOk={() => setModal1Open(false)}
        onCancel={props.onCancel}
        maskClosable={false}
        closable={true}
        closeIcon={<Button aria-hidden="true" icon="fa fa-times" className="btn btn-primary"  />}
        // closeIcon={<span aria-hidden="true">×</span>}
        centered={false}
        style={{
          top: `${HEADER_OFFSET_PX}px`, // Keep modal below the fixed header
          left: leftMargin, // Adjust for sidebar width (example: 200px for a sidebar)
          margin: 0,
          padding: 0,
          position: "absolute", // Ensure it's positioned under the header and sidebar
        //   width: `100vh`, // Fit to the remaining content area width
          height: `calc(100vh - ${HEADER_OFFSET_PX}px)`, // Prevent bottom clipping (esp. mobile)
          maxHeight: `calc(100vh - ${HEADER_OFFSET_PX}px)`,
        }}
        styles={{
          body: {
            // Keep bottom CTA visible above mobile browser bars / iOS safe-area.
            paddingBottom: "calc(24px + env(safe-area-inset-bottom))",
            overflowY: "auto",
          },
        }}
        // bodyStyle={{
        //     display: "flex", // Flexbox for content stretching
        //     flexDirection: "column", // Vertical stacking
        //     padding: 0, // Remove default padding
        //     height: "100%", // Fill modal height
        //     overflow: "hidden", // Prevent modal overflow
        //   }}
      >
        {props.children}
      </Modal>
    </>
  );
};

export default BaseModal;
